import styled from 'styled-components/macro';

const OperatorSegment = styled('div')`
  width: 180px;
  padding-right: 20px;
`;

export default OperatorSegment;
